import PropTypes from "prop-types"

import Button from "components/ui/button"
import { cn } from "styles/utils"

export const ItemTitle = ({ className = "", ...props }) => (
  <h3
    className={cn(
      "text-16 leading-18 font-medium tracking-tight text-black",
      className
    )}
    {...props}
  />
)

export const ItemAction = ({ className = "", ...props }) => (
  <Button
    className={cn("text-14 leading-22 block w-fit font-light", className)}
    text
    variant="secondary"
    {...props}
  />
)

export const AddonSlider = ({ className = "", ...props }) => (
  <ul
    className={cn(
      "overscroll-touch relative flex list-none gap-8 overflow-y-hidden overflow-x-scroll",
      className
    )}
    {...props}
  />
)

export const AddonItem = ({ className = "", disabled, ...props }) => (
  <li
    className={cn(
      "relative",
      disabled ? "opacity-50" : "opacity-100",
      className
    )}
    {...props}
  />
)

export const AddonButton = ({ className = "", selected, ...props }) => (
  <Button
    className={cn(
      "relative rounded-md focus-visible:-outline-offset-2",
      selected ? "border-selected border-2" : "border-none",
      className
    )}
    text
    {...props}
  />
)

export const TitleDivider = ({ className = "", ...props }) => (
  <div
    className={cn(
      "before:border-grey-20 after:border-grey-20 tablet:before:border-0 tablet:after:border-0 tablet:before:flex-none tablet:before:mr-0 flex items-center before:mr-10 before:flex-1 before:border-b after:ml-10 after:flex-1 after:border-b",
      className
    )}
    {...props}
  />
)

export const QtyIcon = ({ className = "", ...props }) => (
  <Button
    className={cn(
      "text-grey-65 -my-4 px-8 py-4 focus:outline-2 focus:outline-white",
      className
    )}
    {...props}
  />
)

export const MainContainer = ({ className = "", ...props }) => (
  <div
    className={cn("tablet:gap-16 desktop:flex-1 flex flex-col", className)}
    {...props}
  />
)

export const SidePanelWrapper = ({ className = "", ...props }) => (
  <div
    className={cn(
      "desktop:h-full desktop:sticky desktop:top-24 desktop:w-1/3 w-full",
      className
    )}
    {...props}
  />
)

export const Panel = ({ className = "", ...props }) => (
  <div
    className={cn(
      "tablet:px-24 tablet:border tablet:mb-16 tablet:mx-0 border-grey-20 -mx-16 border-0 border-solid bg-white px-16 py-24",
      className
    )}
    {...props}
  />
)

export const ShadowBox = ({ className = "", ...props }) => (
  <div
    className={cn(
      "border-grey-20 border bg-white px-12 py-24 shadow-lg",
      className
    )}
    {...props}
  />
)

export const DetailText = ({ className = "", ...props }) => (
  <p className={cn("text-12 leading-14 font-medium", className)} {...props} />
)

export const RetailPrice = ({ className = "", ...props }) => (
  <p
    className={cn(
      "text-grey-65 text-12 tablet:font-medium font-light leading-none tracking-wide",
      className
    )}
    {...props}
  />
)

export const LinkButton = ({ className = "", ...props }) => (
  <Button
    className={cn(
      "text-14 leading-20 tablet:font-light mx-auto flex w-fit font-medium tracking-tight",
      className
    )}
    text
    underline
    variant="secondary"
    {...props}
  />
)

ItemTitle.propTypes = {
  className: PropTypes.string,
}
ItemAction.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
}
AddonSlider.propTypes = {
  className: PropTypes.string,
}
AddonItem.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
}
TitleDivider.propTypes = {
  className: PropTypes.string,
}

QtyIcon.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
}

MainContainer.propTypes = {
  className: PropTypes.string,
}
DetailText.propTypes = {
  className: PropTypes.string,
}
RetailPrice.propTypes = {
  className: PropTypes.string,
}
LinkButton.propTypes = {
  className: PropTypes.string,
}
ShadowBox.propTypes = {
  className: PropTypes.string,
}
Panel.propTypes = {
  className: PropTypes.string,
}
SidePanelWrapper.propTypes = {
  className: PropTypes.string,
}
AddonButton.propTypes = {
  className: PropTypes.string,
  selected: PropTypes.string,
}
